import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { ui } from "../data/ui";
import type { Lang } from "../types/i18n";
const options: {
  value: Lang;
  label: string;
  full: string;
}[] = [{
  value: "en",
  label: "EN",
  full: "English"
}, {
  value: "es",
  label: "ES",
  full: "Español"
}];
export function LanguageToggle() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div role="group" aria-label={t(ui.common.language)} className="flex items-center text-xs font-semibold tracking-wider" data-id="element-258" data-mp="25ho104h4veeh">
      {options.map((opt, i) => <React.Fragment key={opt.value} data-id="element-259" data-mp="21erg2744f67d" data-mpi={i}>
          {i > 0 && <span className="px-1 text-white/30" aria-hidden="true" data-id="element-260" data-mp="2f90v72qemgno">/</span>}
          <button type="button" lang={opt.value} aria-pressed={lang === opt.value} aria-label={opt.full} onClick={() => setLang(opt.value)} className={`min-h-[32px] min-w-[32px] rounded-sm px-1.5 transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold ${lang === opt.value ? "text-gold" : "text-white/60 hover:text-white"}`} data-id="element-261" data-mp="2ahiri6wzy1z0">
            {opt.label}
          </button>
        </React.Fragment>)}
    </div>;
}